import React, { FC } from 'react';

type Props = {
  name: string;
  className?: string;
  'data-doctrine-popover'?: boolean;
};

export const MaterialIcon: FC<Props> = ({ name, className = '', ...props }) => (
  <i className={`material-icons icons__${name} ${className}`} {...props} />
);
